import styled, { css } from "styled-components"
import { className } from "./articleList.className"
import { Link } from "gatsby"
import Img from "../gatsbyImage/gatsbyImage"
import SameRatioContainer from "../sameRatioContainer/sameRatioContainer"
import { device } from "../mediaQuery/mediaQuery"

export const ArticleWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`
const titleAreaHoverStyle = css`
  transform: translateY(0);

  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 10px 10px 0 0;
  opacity: 0.9;
`
export const Article = styled(Link)`
  box-sizing: border-box;
  margin-bottom: 15px;
  text-decoration: none;
  color: black;

  @media ${device.tablet} {
    width: 100%;

    :not(:last-child) {
      margin-bottom: 15px;
    }
  }
  @media ${device.desktop} {
    width: 24.4%;
    :not(:nth-child(4n)) {
      margin-right: 0.8%;
    }
    :hover {
      cursor: pointer;
    }

    :hover .${className.image} {
      opacity: 0.6;
    }
    :hover .${className.titleArea} {
      ${titleAreaHoverStyle}
    }
    :hover .${className.context} {
      opacity: 1;
    }
  }
`
export const ImageArea = styled.div`
  position: relative;
`

export const TitleArea = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;

  transform: translateY(65%);
  background-color: #f7f7f7;
  color: ${props => props.color};
  border: 3px solid ${props => props.color};
  z-index: 1;
  transition: transform 0.5s, width 0.5s, height 0.5s;
  :before {
    content: "";
    display: inline-block;
    height: 100%;
    width: 0;
    vertical-align: middle;
  }

  @media ${device.tablet} {
    ${titleAreaHoverStyle}
  }
  @media ${device.desktop} {
    width: 80%;
    height: 80%;
  }
`
export const TitleWrap = styled.div`
  width: 100%;
  display: inline-block;
  vertical-align: middle;
  padding:0 8px;
  box-sizing:border-box;
`
export const DateLabel = styled.p`
  font-size: 18px;
  text-align: center;
  margin-bottom: 10px;
`
export const Hr = styled.hr`
  width: 95%;
  margin-top: 10px;
  margin-bottom: 15px;
`
export const ArticleTitle = styled.h3`
  text-align: center;
  font-size: 20px;
  font-weight: bold;
`
export const ImgWrap = styled(SameRatioContainer)`
  border-radius: 10px 10px 0 0;

  @media ${device.tablet} {
    opacity: 0.6;
  }
  @media ${device.desktop} {
  }
`
export const ContextArea = styled.div`
  background-color: ${props => props.color};
  padding: 15px;
  box-sizing: border-box;
  border-radius: 0 0 10px 10px;
  min-height: 140px;
`
export const Context = styled.p`
  font-size: 18px;
  line-height: 1.5;
  opacity: 0;
  color: white;
  /* 刪節號 */
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${device.tablet} {
    opacity: 1;
  }
  @media ${device.desktop} {
  }
`
